import { Fancybox } from '@fancyapps/ui';
import './front-video-lightbox.scss';

window.addEventListener( 'load', function () {
	Fancybox.bind( '[data-fancybox]', {} );
} );
